/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// name the functions different than the constants, or the Saga will not be called

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  orderTags: ["postId", "forced"],
  orderPreflight: ["postId", "itemId"],
  orderConfirm: ["postId", "itemId", "params"],
  orderPurchase: ["postId", "params"],
  orderComplete: ["result"],
  orderRequest: ['data'],
  orderSuccess: ['payload'],
  orderFailure: null,
  orderEndorseRequest: ['data'],
  orderEndorseSuccess: ['response'],
  orderEndorseFailure: null,
  orderBoughtRequest: ['data'],
  orderBoughtSuccess: ['response'],
  orderBoughtFailure: null,
  orderSoldRequest: ['data'],
  orderSoldSuccess: ['response'],
  orderSoldFailure: null,
  orderDetailRequest: ['data'],
  orderDetailSuccess: ['response'],
  orderDetailFailure: null,
  orderShipRequest: ['data'],
  orderShipSuccess: ['response'],
  orderShipFailure: null,
  orderPurchaseRequest: ['data'],
  orderPurchaseSuccess: ['response'],
  orderPurchaseFailure:  ['response']
})

export const OrderTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: null,
  kind: null,
  postId: null,
  tags: null,
  lineItems: null,
  itemId: null,
  item: null,
  order: null,
  meta: null,
  error: null,
  logRef: null,
  modified: null,
  data: null,
  payload: null,
  endorse: null,
  bought: null,
  sold: null,
  detail: null,
  shipped: null,
  result : null,
  purchaseSuccess : null,
  errorPurchase : null
})

const FETCH_START = Immutable({
  fetching: true,
  lineItems: null,
  itemId: null,
  item: null,
  order: null,
  meta: null,
  error: null,
  logRef: null,
})

/* ------------- Selectors ------------- */

export const OrderSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */

export const tags = (state, action) => {
  const { postId, forced = false } = action
  console.log(`tags orderTags postId ${postId}, forced ${forced}`)
  if (!forced && postId == state.postId)
    return state.merge(Object.assign({}, FETCH_START, { kind: 'tags', modified: (new Date()).getTime() }))
  else
    return state.merge(Object.assign({}, FETCH_START, { kind: 'tags', tags: null, postId: postId, modified: (new Date()).getTime() }))
}

export const preflight = (state, action) => {
  const { postId, itemId } = action
  return state.merge(Object.assign({}, FETCH_START, { kind: 'preflight', postId: postId, itemId: itemId, modified: (new Date()).getTime() }))
}

export const confirm = (state, action) => {
  const { postId, itemId } = action
  return state.merge(Object.assign({}, FETCH_START, { kind: 'confirm', postId: postId, itemId: itemId, modified: (new Date()).getTime() }))
}

export const purchase = (state, action) => {
  const { postId, itemId } = action
  return state.merge(Object.assign({}, FETCH_START, { kind: 'purchase', postId: postId, itemId: itemId, modified: (new Date()).getTime() }))
}

// completed order action (success or fail - we have partial failures in the preflight/confirm/purchase calls)
export const complete = (state, action) => {
  console.tron.display({
  name: `order complete redux`,
   preview :``,
  value: {
  state: action
  }
  })

  return state.merge({ fetching: false, modified: (new Date()).getTime() ,result : action.result,...action.result})
}

// request the data from an api
export const request = (state, { data }) =>
  state.merge({ fetching: true, data, payload: null })

// successful api lookup
export const success = (state, action) => {
  const { payload } = action
  return state.merge({ fetching: false, error: null, payload })
}

// Something went wrong somewhere.
export const failure = state =>
  state.merge({ fetching: false, error: true, payload: null })

export const orderPurchaseRequest = (state, action) =>
  state.merge({ fetching: true })

// successful api lookup
export const orderPurchaseSuccess = (state, action) => {
  console.tron.display({
    name: `orderPurchaseSuccess`,
    preview: ``,
    value: {
      state: action
    }
  })
  const { response : {data} } = action
  return state.merge({ fetching: false, errorPurchase: null ,purchaseSuccess  :data })
}

// Something went wrong somewhere.
export const orderPurchaseFailure = (state,action) => {
  const {response: {data :{errors}}} =  action
  const error = errors[0]

  return state.merge({ fetching: false ,purchaseSuccess : null , errorPurchase : error })
}

const sortOrders = (state, data) => (state ? [...state, ...data] : data).sort((a,b) => b.TimeStamp - a.TimeStamp)

// request the data from an api
export const orderEndorseRequest = (state, { data }) =>
  state.merge({ fetching: true, data })

// successful api lookup
export const orderEndorseSuccess = (state, action) => {
  const { response: { data: { data, pagination } } } = action
  console.tron.display({ name: `orderEndorseSuccess`, preview: ``, value: { data, pagination }})
  let sorted = pagination.from == 0 ? sortOrders(null, data) : sortOrders( state.endorse, data )
  return state.merge({ fetching: false, error: null, endorse: sorted })
}

// Something went wrong somewhere.
export const orderEndorseFailure = state =>
  state.merge({ fetching: false, error: true, endorse: null })
export const orderBoughtRequest = (state, { data }) =>
  state.merge({ fetching: true, data, bought: null })

// successful api lookup
export const orderBoughtSuccess = (state, action) => {
  const { response: { data: { data, pagination } } } = action
  console.tron.display({ name: `orderBoughtSuccess`, preview: ``, value: { data, pagination }
  })
  let sorted = pagination.from == 0 ? sortOrders(null, data) : sortOrders( state.bought, data )
  return state.merge({ fetching: false, error: null, bought: sorted })
}

// Something went wrong somewhere.
export const orderBoughtFailure = state =>
  state.merge({ fetching: false, error: true, bought: null })
export const orderSoldRequest = (state, { data }) =>
  state.merge({ fetching: true, data })

// successful api lookup
export const orderSoldSuccess = (state, action) => {
  const { response: { data: { data, pagination } } } = action
  console.tron.display({name: `orderSoldSuccess`, preview: ``, value: { data, pagination }})
  let sorted = pagination.from == 0 ? sortOrders(null, data) : sortOrders( state.sold, data )
  return state.merge({ fetching: false, error: null, sold: sorted })
}

// Something went wrong somewhere.
export const orderSoldFailure = state =>
  state.merge({ fetching: false, error: true, sold: null })
export const orderShipRequest = (state, { data }) =>
  state.merge({ fetching: true, data, shipped: null })

// successful api lookup
export const orderShipSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  console.tron.display({
    name: `orderShipSuccess aa`,
    preview: ``,
    value: {
      state: data
    }
  })

  return state.merge({ fetching: false, error: null, shipped: true })
}

// Something went wrong somewhere.
export const orderShipFailure = state =>
  state.merge({ fetching: false, error: true, shipped: null })
export const orderDetailRequest = (state, { data }) =>
  state.merge({ fetching: true, data, detail: null })

// successful api lookup
export const orderDetailSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  console.tron.display({
    name: `orderDetailSuccess`,
    preview: ``,
    value: {
      state: data
    }
  })

  return state.merge({ fetching: false, error: null, detail: data })
}

// Something went wrong somewhere.
export const orderDetailFailure = state =>
  state.merge({ fetching: false, error: true, detail: null })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ORDER_TAGS]: tags,
  [Types.ORDER_PREFLIGHT]: preflight,
  [Types.ORDER_CONFIRM]: confirm,
  [Types.ORDER_PURCHASE]: purchase,
  [Types.ORDER_COMPLETE]: complete,
  [Types.ORDER_REQUEST]: request,
  [Types.ORDER_SUCCESS]: success,
  [Types.ORDER_FAILURE]: failure,
  [Types.ORDER_ENDORSE_REQUEST]: orderEndorseRequest,
  [Types.ORDER_ENDORSE_SUCCESS]: orderEndorseSuccess,
  [Types.ORDER_ENDORSE_FAILURE]: orderEndorseFailure,
  [Types.ORDER_BOUGHT_REQUEST]: orderBoughtRequest,
  [Types.ORDER_BOUGHT_SUCCESS]: orderBoughtSuccess,
  [Types.ORDER_BOUGHT_FAILURE]: orderBoughtFailure,
  [Types.ORDER_SOLD_REQUEST]: orderSoldRequest,
  [Types.ORDER_SOLD_SUCCESS]: orderSoldSuccess,
  [Types.ORDER_SOLD_FAILURE]: orderSoldFailure,
  [Types.ORDER_DETAIL_REQUEST]: orderDetailRequest,
  [Types.ORDER_DETAIL_SUCCESS]: orderDetailSuccess,
  [Types.ORDER_DETAIL_FAILURE]: orderDetailFailure,
  [Types.ORDER_SHIP_REQUEST]: orderShipRequest,
  [Types.ORDER_SHIP_SUCCESS]: orderShipSuccess,
  [Types.ORDER_SHIP_FAILURE]: orderShipFailure,

  [Types.ORDER_PURCHASE_REQUEST]: orderPurchaseRequest,
  [Types.ORDER_PURCHASE_SUCCESS]: orderPurchaseSuccess,
  [Types.ORDER_PURCHASE_FAILURE]: orderPurchaseFailure
})
